import interceptor from '@/plugins/interceptor';
const pathController = '/TrafficLogFile'

export default {
  state: () => ({
  }),
  getters: {
  },
  mutations: {
  },
  actions: {
    async trafficLogFile_get({ dispatch }, { stationId, date }) {
      try {
        const request = await interceptor.authenticate.get(`${process.env.VUE_APP_API_URL}${pathController}/getTrafficLog?stationId=${stationId}&date=${date}`);
        return { ok: true, data: request.data };
      } catch (error) {
        if (error.response && error.response.status === 404) {
          return { ok: true, data: null };
        }
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${window.vueApp.$t('workspace.log_editor.load_error')}`, title: window.vueApp.$t('left_menu.spot_programming.log_editor'), error: true});
        return { ok: false, data: null };
      }
    },
    async trafficLogFile_save({ dispatch }, model) {
      try {
        const request = await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/saveTrafficLog`, model);
        return { ok: true, data: request.data };
      } catch (error) {
        const status = error.response ? error.response.status : null;
        const code = error.response && typeof error.response.data === 'string' ? error.response.data : null;

        // 404 (log gone), 409 (version conflict / generation pending) and the 400 edit-rejection
        // codes carry meaning the caller needs to react to differently, so hand them back as-is.
        if (status === 404 || status === 409 || status === 400) {
          return { ok: false, status, code };
        }

        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${window.vueApp.$t('workspace.log_editor.save_error')}`, title: window.vueApp.$t('left_menu.spot_programming.log_editor'), error: true});
        return { ok: false, status, code: null };
      }
    }
  }
}
